import React, {useEffect, useState} from 'react';

import "./DropDownFolder.scss";
import DropDown from "../DropDown";
import ModalComponent from "../../modals/ModalComponent";
import CreateFolder from "../../template/CreateFolder";
import EditCollectionFolders from "../../EditCollectionFolders";

const DropDownFolder = ({listTitle, list, getSelectFolder, addFolder, editFolder}) => {

  useEffect(() => {
    setDropDownTitle(listTitle);
  }, []);

  const [isCreateFolderModal, setCreateFolderModal] = useState(false);
  const [isEditFolderModal, setEditFolderModal] = useState(false);
  const [dropDownTitle, setDropDownTitle] = useState(null);

  const openCreateFolderModal = () => {
    setCreateFolderModal(true);
  };

  const closeCreateFolderModal = () => {
    setCreateFolderModal(false);
  };

  const openEditFolderModal = () => {
    setEditFolderModal(true);
  };

  const closeEditFolderModal = () => {
    setEditFolderModal(false);
  };

  const setNewListTitle = (originalNameFolder, newListTitle) => {
    if(listTitle === originalNameFolder) {
      getSelectFolder(newListTitle);
    }
  };

  const deleteTitle = (originalNameFolder) => {
    if(listTitle === originalNameFolder) {
      getSelectFolder(list[0]);
    }
  };

  return (
    <div className="drop-down-folder">
      <DropDown
        listTitle={listTitle}
        category="Folder"
        list={list}
        submitClick={getSelectFolder}
      />
      <p className="drop-down-folder__create"
        onClick={editFolder ? openEditFolderModal : openCreateFolderModal}
      >
        { editFolder ? "Edit folder" : "Create folder" }
      </p>
      <ModalComponent
        onCloseModal={closeCreateFolderModal}
        isVisible={isCreateFolderModal}
        text={"create-folder"}
      >
        <CreateFolder closeCreateFolderModal={closeCreateFolderModal} addOrEditFolder={addFolder} type={"create"} />
      </ModalComponent>
      <ModalComponent
        onCloseModal={closeEditFolderModal}
        isVisible={isEditFolderModal}
        text={"edit-folder"}
      >
        <EditCollectionFolders closeEditFolderModal={closeEditFolderModal} list={list} setNewListTitle={setNewListTitle} deleteTitle={deleteTitle} />
      </ModalComponent>
    </div>
  );
};

export default DropDownFolder;